import type {
  InviteMemberRequest,
  MemberResponse,
  UpdateMemberRoleRequest,
} from '@tabita/contracts';
import { apiRequest } from './api-client';

export const administrationApi = {
  listMembers() {
    return apiRequest<readonly MemberResponse[]>('/administration/members');
  },

  invite(body: InviteMemberRequest) {
    return apiRequest<MemberResponse>('/administration/invite', { method: 'POST', body });
  },

  updateMemberRole(membershipId: string, body: UpdateMemberRoleRequest) {
    return apiRequest<MemberResponse>(`/administration/members/${membershipId}`, {
      method: 'PATCH',
      body,
    });
  },

  removeMember(membershipId: string) {
    return apiRequest<void>(`/administration/members/${membershipId}`, { method: 'DELETE' });
  },
};
